import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '@reduxjs/toolkit/query'
import { persistor } from 'store'
import Api from "services/api"

export const initUser = {
  token: undefined,
  user: undefined,
  intro: true,
  loader: false,
  isAuthenticated: false,
  error: {}
}

// export const initialState: IUserState = {
//   name: '',
//   drawerOpen: false,
//   user: {
//     name: 'Chintan',
//     email: 'chintan@gmail.com',
//     phone: '+91 9999999999'
//   },
//   intro: true,
//   loader: false,
//   keyboardVisible: false
// }

export const userSlice = createSlice({
  name: 'user',
  initialState: initUser,
  reducers: {
    setUser: (state, { payload }) => {
      state.user = payload.data
      state.isAuthenticated = true;
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
    setIntro: (state, { payload }) => {
      state.intro = payload
    },
    setLogout: (state, { payload }) => {
      state.user = payload
      state.isAuthenticated = false;
    },
  }
})

// const reducer = (state = initialState, action) => {
//   switch (action.type) {
//     case types.INIT_APP:
//     case types.GO_TO_DETAILS:
//       return { ...state, ...action.payload }
//     default:
//       return state
//   }
// }

export const login = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.login(data)
    if (json.status >= 200 && json.status < 300) {
      dispatch(setUser(json.data))
      Api.setClientToken(json?.data?.data?.token);
      callback(true)
    } else if (json.status == 401) {
      dispatch(setError(json.data))
      callback(false)
    }
  } catch (error) {
    console.log(error)

  }
  dispatch(setLoader(false))
  // return json;
};

// register
export const register = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.signup(data)
    if (json.status >= 200 && json.status < 300) {
      dispatch(setUser(json.data))
      Api.setClientToken(json?.data?.data?.token);
      callback(true)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
  // return json;
};


export const forgotPassword = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.forgotPassword(data)
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message, json.data?.token)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
    else {
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
  // return json;
};


export const resetPassword = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.resetPassword(data)
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
  // return json;
};

export const logout =
  (navigation, routes, ndispatch) => async (dispatch) => {

    persistor.purge() // Clears the persisted state
    dispatch(setLogout(initUser))
    setTimeout(() => {
      localStorage.removeItem("persist:root");

      persistor.purge() // Clears the persisted state
      localStorage.removeItem("persist:root");
      window.location.reload("/login")
    }, 500);
  }

export const { setUser, setLoader, setError, setIntro, setLogout } = userSlice.actions
export const userSelector = state => state.user


export default userSlice.reducer
